import { defaultTo } from "lodash/fp";

export const appVersion = defaultTo("unknown", process.env.COMMIT_REF || process.env.REACT_APP_BUILD_ID);

export const env = process.env.NODE_ENV;

export const isTestEnv = () => env === "test";
